import { ComponentClassNames } from '../../util/classNames';
import { memoizeFunction, mergeStyleSets } from '../../util/styling';

import { BorderRadius } from './Image.types';

export interface ImageStyleProps {
  readonly borderRadius?: BorderRadius;
  readonly fullHeight?: boolean;
  readonly fullWidth?: boolean;
  readonly limitMaxWidth?: boolean;
  readonly block?: boolean;
  readonly className?: string;
  readonly allowClickThroughOnFrame?: boolean;
}

type GetClassNames = (props: ImageStyleProps) => ComponentClassNames<'image' | 'zoomWrapper'>;
export const getClassNames: GetClassNames = (props) =>
  getClassNamesMemoized(
    props.borderRadius,
    props.fullHeight,
    props.fullWidth,
    props.limitMaxWidth,
    props.block,
    props.className,
    props.allowClickThroughOnFrame
  );

const getClassNamesMemoized = memoizeFunction(
  (
    borderRadius: ImageStyleProps['borderRadius'],
    fullHeight: ImageStyleProps['fullHeight'],
    fullWidth: ImageStyleProps['fullWidth'],
    limitMaxWidth: ImageStyleProps['limitMaxWidth'],
    block: ImageStyleProps['block'],
    className: ImageStyleProps['className'],
    allowClickThroughOnFrame: ImageStyleProps['allowClickThroughOnFrame']
  ) => {
    const height = fullHeight ? '100%' : undefined;
    const maxWidth = limitMaxWidth ? '100%' : undefined;

    return mergeStyleSets({
      image: [
        {
          display: fullWidth || block ? 'block' : 'inline-block',
          height,
          borderRadius,
          maxWidth,
          pointerEvents: allowClickThroughOnFrame ? 'none !important' : undefined,

          selectors: {
            '> .ms-Image-image': {
              maxWidth,
              pointerEvents: allowClickThroughOnFrame ? 'auto' : undefined,
            },
          },
        },
        className,
      ],
      zoomWrapper: {
        pointerEvents: allowClickThroughOnFrame ? 'none !important' : undefined,
      },
    });
  }
);
